import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { auth } from '../firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true,
      isHome: true
    }
  },
  {
    path: '/category/:category/:subcategory/:language?',
    name: 'category',
    props: true,
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: Home,
    meta: {
      requiresAuth: true,
      isSearch: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '*',
    name: 'not-found',
    meta: {
      requiresAuth: false,
      isNotFound: true
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

const isSessionValid = function() {
  var expDate = parseInt(localStorage.getItem('bd-biblio-session') || '0')
  return Date.now() < expDate
}

router.beforeEach((to, from, next) => {
  if (
    window.location.hostname != 'bd-bibliociencia.com' &&
    window.location.hostname != 'localhost'
  ) {
    window.location.href = 'https://bd-bibliociencia.com'
  }

  if (to.matched.some(record => record.meta.isNotFound)) {
    window.location = '/'
  }
  // CHeck for requiredAuth guard
  else if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if not logged in
    if (!auth.currentUser || !isSessionValid()) {
      if (auth.currentUser) {
        auth.signOut().then(() => {
          window.location = '/login'
        })
      } else {
        // Go to login
        next({
          path: 'login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if logged in
    if (auth.currentUser && isSessionValid()) {
      // Go to home
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})

export default router
